/**
 * @fileOverView
 * @description Single Vyb Page View<br>
 * @copyright 2015-present Flatirontek LLC
 **/

var SoundsPageTemplate = require('../../templates/pages/soundspage.html');
var AmpersandView = require('ampersand-view');
var HeaderView = require('../widgets/header');
var FooterView = require('../widgets/footer');
var SoundAcquisitionView = require('../widgets/soundacquisitionview');
var app = require('ampersand-app');

var SoundAcquisitionPageView = AmpersandView.extend({

    template : SoundsPageTemplate,

    initialize: function(options){
        this.mode = options.mode!=undefined ? options.mode : 'lib';
        console.log(this.mode);
    },

    pageName: "SoundAcquisitionPage",

    subviews: {
        mpheader: {
            selector : 'header',
            prepareView: function(el) {
                app.currentPageName = this.pageName;
                return new HeaderView({
                    el: el,
                    parent: this,
                    maintitle: 'Sound Acquisition'
                });
            }
        },

        mpfooter: {
            selector : 'footer',
            prepareView: function(el) {
                return new FooterView({
                    el: el,
                    parent: this
                });
            }
        },

        sounds: {
            selector : '#content',
            prepareView: function(el) {
                return new SoundAcquisitionView({
                    el: el,
                    parent: this,
                    mode: this.mode
                });
            }
        }
    }
});

module.exports = SoundAcquisitionPageView;
